import Icons, { IconsProps } from '../../Icons';

export type ReturnsProps = IconsProps;

// https://www.zhangxinxu.com/sp/svgo/
// https://jakearchibald.github.io/svgomg/

export function Returns(props: ReturnsProps) {
  return (
    <Icons {...props}>
      <path d="M20.054 14.397a.36.36 0 0 1 .274-.02l-.001.001a.358.358 0 0 1 .23.455c-1.611 4.736-6.608 7.249-11.377 5.723a8.817 8.817 0 0 1-5.19-4.44 8.976 8.976 0 0 1-.53-6.936 8.942 8.942 0 0 1 4.504-5.214A8.973 8.973 0 0 1 12.004 3a9.013 9.013 0 0 1 6.824 3.142l.208.24.323-1.943a.35.35 0 0 1 .412-.293.357.357 0 0 1 .294.411l-.461 2.79a.352.352 0 0 1-.412.296l-2.793-.461a.357.357 0 0 1-.244-.544.355.355 0 0 1 .363-.163l1.929.317-.281-.315a8.16 8.16 0 0 0-3.558-2.335c-4.336-1.434-9.031.927-10.465 5.26-1.434 4.336.929 9.032 5.266 10.47a8.224 8.224 0 0 0 6.32-.468 8.227 8.227 0 0 0 4.145-4.799.36.36 0 0 1 .18-.208Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m12.267 18.009-.01.004.026.064.017.075-.06-.138.038.144-.07-.14-.027.001-.025-.001-.01.13v-.131l-.06-.017h-.018l-5.033-2.441a.322.322 0 0 1-.183-.29v-6.1a.325.325 0 0 1 .184-.28l5-2.425a.338.338 0 0 1 .284 0l4.938 2.396.026.01a.315.315 0 0 1 .226.233l.015.057v6.102a.326.326 0 0 1-.183.29l-5.02 2.435-.055.02v.002ZM7.912 9.183l4.266 2.069 2-.969-4.266-2.069-2 .969Zm-.413 5.881 4.356 2.112v-5.361L7.499 9.704v5.36Zm8.946-5.881-4.267-2.068-1.525.741 4.266 2.067 1.526-.74Zm-3.943 7.992 4.37-2.12V9.694l-1.712.83v2.685a.324.324 0 0 1-.647 0v-2.37l-2.011.976v5.36Z"
      />
    </Icons>
  );
}
